import { LeadGenerationSource } from 'testDrive/constants';
import { useSelector } from 'react-redux';
import SimilarRangeCars from 'testDrive/components/Widgets/SimilarRangeCars';
import { useTestDriveLocation } from 'testDrive/hooks/useTestDriveLocation';
import { BackButton, Modal, Typography } from 'ui';
import s from './ServicablePopup.module.scss';

interface ServicablePopupProps {
  show: boolean;
  onClose: () => void;
  pageName: string;
  isWeb?: boolean;
  leadGenerationSource?: LeadGenerationSource;
}

const ServicablePopup = ({ show, onClose, pageName ,isWeb = false,leadGenerationSource = null}: ServicablePopupProps) => {
  const address = useSelector((state: any) => state?.testDrive?.address);
  const { oemPayload } = useSelector(
    (state: any) => state?.testDrive?.serviceableData
  );

  return (
    <Modal
      show={show}
      head={{ show: true, onClose: () => onClose() }}
      rootStyle={{ zIndex: 2 }}
      isWeb={isWeb}
    >
      <div className={s.root} id='non_service_location_popup'>
        <BackButton
          type='hidden'
          onBack={() => {
            onClose();
          }}
        />
        <div className={s.text}>
          <Typography
            label='Test drive not available in your city'
            variant='h3'
            style={{ marginBottom: '8px' }}
          />
          <Typography
            label='Don’t worry! We have other models in this city that can be booked for free test drive'
            variant='base_big_r'
            color='text_subheading'
          />
        </div>
        {oemPayload && (
          <SimilarRangeCars
            address={address}
            pageName={pageName as any}
            title=''
            userDetails={null}
            payload={oemPayload}
            bgLess
            defaultSingleCheck
            leadGenerationSource={leadGenerationSource}
          />
        )}
      </div>
    </Modal>
  );
};

export default ServicablePopup;
